export default __webpack_public_path__ + "static/media/information--go-straight-or-turn-left--g1.fe58d18a.png";